module["exports"] = [
  "ბ-ნი",
  "ბატონი",
  "ქ-ნი",
  "ქალბატონი"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/ge/name/prefix.js
// module id = 1389
// module chunks = 1